import React, { FC, useContext } from 'react'

import { ProfitSummaryButton } from '../../components/Estimates/ProfitSummary/ProfitSummaryButton'
import SummaryPanel from '../../components/SharedUI/SummaryPanel/SummaryPanel'
import useAuthorizationsById from '../../hooks/useAuthorizations/useAuthorizationsById'
import { FeatureFlags } from '../../models/FeatureFlags'
import { RO_CLOSED } from '../../models/Status'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'

interface Props {
  repairOrderId: string
}

const SummaryPanelContainer: FC<Props> = ({ repairOrderId }) => {
  const { repairOrder, fetchingRepairOrders } = useContext(RepairOrderContext)
  const { previousTotal } = useAuthorizationsById(repairOrderId)
  const { featureFlags } = useContext(AppContext)
  return (
    <>
      {repairOrder && (
        <SummaryPanel
          repairOrder={repairOrder}
          authorizedAmount={previousTotal || 0}
          readOnly={repairOrder.entry!.info!.status === RO_CLOSED}
          showUpdating={fetchingRepairOrders}
          enableDiscount={
            !!featureFlags && !!featureFlags[FeatureFlags.ShopDiscount]
          }
          profitSummary={<ProfitSummaryButton />}
        />
      )}
    </>
  )
}

export default SummaryPanelContainer
